import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, FreeMode } from 'swiper';
import Rating from 'react-rating';
import "./RestaurantCard.css";
import pet from "./../../../Assets/Icons/pet.png"
import LeoImg from './../../../Assets/Image/Leo.png';

// Import Swiper styles
import 'swiper/css';

import '../ProductComponents/ProductCard.css';
import { sliceText } from '../../../utils/sliceText';
import { Button, Modal } from 'react-bootstrap';

function RestaurantCard({ restaurant, img1, img2, img3, img4, text }) {
  const [categories, setCategories] = useState("");
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const [showPrev, setShowPrev] = useState(false);
  const [showNext, setShowNext] = useState(false);
  const [showSchedule, setShowSchedule] = useState(false);
  const [colseScheduler, setCloseScheduler] = useState(false);
  const timeSchedule = useRef(null);

  const openScheduleModal = () => {
    setShowSchedule(true);
  };

  const closeScheduleModal = () => {
    setShowSchedule(false);
    setCloseScheduler(true);

    setTimeout(() => {
      setCloseScheduler(false);
    }, 2000);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        timeSchedule.current &&
        !timeSchedule.current.contains(event.target)
      ) {
        closeScheduleModal();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const category = restaurant.categories.map((data) => data.categoryName);
    setCategories(category.slice(0, 5).join(" | "));
  }, [restaurant]);

  const HandleSliderChange = (swiper) => {

    if (swiper.isEnd) {
      setShowNext(false);
    } else {
      setShowNext(true);
    }

    if (swiper.isBeginning) {
      setShowPrev(false);
    } else {
      setShowPrev(true);
    }
  };

  const HandleSliderChange2 = (swiper) => {

    if (swiper.isEnd) {
      // setShowNext(false);
    } else {
      setShowNext(true);
    }
  };

  useEffect(() => {
    const content = document.querySelector('.swiper-wrapper');
    const content2 = document.querySelector('.swiper-horizontal');

    if (content || content2) {
      const isScrollable = content.scrollWidth > content.clientWidth;
      const isScrollable2 = content2.scrollWidth > content.clientWidth;
      if (isScrollable || isScrollable2) {
        setShowNext(true);
      }
    }
  }, [restaurant, img4]);
  return (
    <div className='restaurantSwipper' style={{ maxWidth: '100%', marginLeft: '0px' }}>
      {/* <div className='box searchProductWidth'> */}
      <div className='restaurant-search-container'>
        <div className='foodcart'>
          {/* <div className="d-flex justify-content-start ">
                            <h3 class="badge pill">Chef Special</h3>
                        </div> */}
          {/* <div className='d-flex justify-content-end cartIcon'>
            <img src={plusIcon} alt='' style={{ width: '20px' }} />
          </div> */}

          {/* ---- Image Carousel --- */}
          <div className="restaurant-swiper-container">
            {/* <button ref={prevRef} className="custom-prev">❮</button> */}

            <button ref={prevRef} className="custom-prev" style={{ display: showPrev ? "" : "none" }}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" role="presentation" focusable="false" style={{ display: "block", height: "12px", width: "12px", fill: "currentcolor" }}><path d="m10.55.3 1.42 1.4L5.67 8l6.3 6.3-1.42 1.4-6.59-6.58a1.58 1.58 0 0 1-.1-2.13l.1-.11z"></path></svg>
            </button>

            <Swiper
              modules={[Navigation, FreeMode]}
              freeMode={true}
              slidesPerView={3}
              onSlideChange={(swiper) => HandleSliderChange(swiper)}
              onSwiper={(swiper) => HandleSliderChange2(swiper)}
              spaceBetween={0}
              pagination={{
                clickable: true,
                dynamicBullets: true,
                dynamicMainBullets: 1,
              }}
              navigation={{
                prevEl: prevRef.current,
                nextEl: nextRef.current,
              }}
              // spaceBetween={2}
              // grabCursor={false}
              // centeredSlides={false}
              // slidesPerView={'auto'}
              // speed={10000}
              // cssMode={true}
              // pagination={{
              //   dynamicBullets: true,
              // }}
              // // slidesPerView={1}
              // navigation={true}
              // modules={[Pagination, Navigation]}
              className='Productfoodcartimg'
              breakpoints={{
                1000: {
                  slidesPerView: 3,
                },
                900: {
                  slidesPerView: 3.5,
                },
                800: {
                  slidesPerView: 3.5,
                },
                700: {
                  slidesPerView: 4,
                },
                600: {
                  slidesPerView: 3.5,
                },
                500: {
                  slidesPerView: 3,
                },
                400: {
                  slidesPerView: 2.2,
                },
                300: {
                  slidesPerView: 2.1,
                },
                0: {
                  slidesPerView: 1,
                },
              }}
            >
              {/* {details?.foodImageList.map((d, i) => {
              return ( */}
              {restaurant?.imagePaths?.length > 0 ?
                restaurant.imagePaths?.map((image, idx) =>
                  <SwiperSlide key={idx} className='MinHeightOfSwiper no-height-container'>
                    <img className='restaurant-swiper-img' src={image} alt='...' />
                  </SwiperSlide>)
                :
                <>
                  <SwiperSlide className='MinHeightOfSwiper no-height-container'>
                    <img src={img1} alt='...' />
                  </SwiperSlide>
                  <SwiperSlide className='MinHeightOfSwiper no-height-container'>
                    <img src={img2} alt='...' />
                  </SwiperSlide>
                  <SwiperSlide className='MinHeightOfSwiper no-height-container'>
                    <img src={img3} alt='...' />
                  </SwiperSlide>
                  <SwiperSlide className='MinHeightOfSwiper no-height-container'>
                    <img src={img4} alt='...' />
                  </SwiperSlide>
                </>
              }
            </Swiper>
            {/* <button ref={nextRef} className="custom-next">❯</button> */}
            <button ref={nextRef} className="custom-next" style={{ display: showNext ? "" : "none" }}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" role="presentation" focusable="false" style={{ display: "block", height: "12px", width: "12px", fill: "currentcolor" }}><path d="M5.41.3 4 1.7 10.3 8 4 14.3l1.41 1.4 6.6-6.58c.57-.58.6-1.5.1-2.13l-.1-.11z"></path></svg>
            </button>
          </div>

          {/* ---- Details --- */}
          <div className='restaurantDetails restaurant-info d-flex flex-column gap-2'>
            {/* resLogo, Name, Rating, category */}
            <div className="d-flex gap-1">
              <img src={restaurant?.restaurantLogo} style={{ width: '50px', height: '50px', marginRight: '5px', borderRadius: '2px' }} />
              <div>
                {/* Name - Rating */}
                <div className='d-flex align-items-center position-relative' >
                  {/* Restaurant Name */}
                  <h4 className='me-2 resName-resCard' >
                    <Link to={`/${restaurant.restaurantUrlName}`} style={{ textDecoration: 'none', color: "black" }}>
                      <b style={{ textTransform: 'capitalize' }}>{restaurant?.restaurantName}</b>
                    </Link>
                  </h4>

                  <h4 className='me-2 resName-resCard-mobile' >
                    <Link to={`/${restaurant.restaurantUrlName}`} style={{ textDecoration: 'none', color: "black" }}>
                      <b style={{ textTransform: 'capitalize' }}>{restaurant?.restaurantName.length > 12 ? restaurant?.restaurantName.substring(0, 12) + ".." : restaurant?.restaurantName}</b>
                    </Link>

                    <span className='resCard-tooltip'>{restaurant?.restaurantName}</span>
                  </h4>

                  {/* Rating */}
                  <div>
                    <Rating
                      className='landingStar pe-1'
                      initialRating={Number(4.5)}
                      emptySymbol='far fa-star icon-color'
                      fullSymbol='fas fa-star icon-color'
                      readonly
                      style={{ fontSize: '14px' }}
                    ></Rating>
                    <span className='ratingNumber text-lg' style={{ fontSize: '14px' }}>4.5</span>{' '}
                    {/* Add this line */}
                  </div>
                </div>
                {/* Category r */}
                <p style={{ fontSize: '14px', textTransform: 'capitalize', fontWeight: '600', margin: '0px' }}>{categories}</p>
                {/* PetFriendly */}
                {restaurant?.isPetFriendly &&
                  <div className='d-flex gap-1'>
                    <img src={pet} style={{ width: '20px', height: '20px' }} />
                    <p style={{ fontSize: '14px', fontWeight: '500', margin: '0px' }}> Pet Friendly </p>
                  </div>
                }
                <p
                  onClick={() => openScheduleModal()}
                  style={{ fontSize: '14px', fontWeight: '600', margin: '0px', textDecoration: "underline", cursor: "pointer" }}>
                  9:00 AM-10:00 PM
                </p>
              </div>
            </div>

            {/* Restaurant Details */}
            <div className='restaurant-Details'>
              <span style={{ textTransform: 'capitalize' }}>
                {sliceText(restaurant?.restaurantDetails, 60)}
              </span>
              <Link to={`/${restaurant.restaurantUrlName}`}><span style={{ marginLeft: '10px' }}>Visit</span></Link>
            </div>

            {/* Review section */}
            <div className='restaurant-Details d-flex align-items-center'>
              <img src={LeoImg} className='me-1 userImg' alt='' />
              <p>
                "Leo Love the art of travel. So many plac So many foods..."{' '}
              </p>
            </div>
          </div>
        </div>

        {/* <hr className='mx-5  m-0 p-0 cartHR' /> */}
      </div>

      {showSchedule && (
        <div
          className="modal show"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Modal.Dialog style={{ width: "370px" }} ref={timeSchedule}>
            <Modal.Header closeButton onClick={() => closeScheduleModal()}>
              <Modal.Title>
                <h5 style={{ fontWeight: "bold" }}>{restaurant?.restaurantName} Opening Hours</h5>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <table style={{ borderCollapse: "collapse", width: "100%" }}>
                <thead>
                  <tr>
                    <th
                      style={{
                        padding: "8px",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      <h6 style={{ margin: 0 }}>Day / Date</h6>
                    </th>
                    <th
                      style={{
                        padding: "8px",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      <h6 style={{ margin: 0 }}>Time</h6>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ padding: "8px", textAlign: "center" }}>
                      Sat - Tues
                    </td>
                    <td
                      style={{
                        borderRight: "none",
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      09:00 AM - 09:00 PM
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: "8px", textAlign: "center" }}>
                      19 Feb 24
                    </td>
                    <td
                      style={{
                        borderRight: "none",
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      09:00 AM - 11:00 PM
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: "8px", textAlign: "center" }}>
                      19 Feb 24
                    </td>
                    <td style={{ padding: "8px", textAlign: "center" }}>
                      09:00 AM - 11:00 PM
                    </td>
                  </tr>
                </tbody>
              </table>
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="success"
                style={{
                  backgroundColor: "transparent",
                  color: "green",
                  fontWeight: "bold",
                }}
                onClick={() => closeScheduleModal()}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal.Dialog>
        </div>
      )}
    </div>
  );
}

export default RestaurantCard;
